import {
  ORDER_DETAIL_RECEIVED,
  ORDER_HISTORY_RECEIVED,
  PATIENT_ORDER_HISTORY_RECEIVED,
  SALES_ORDER_RECEIVED,
} from "../constants/types/orderType";

const initialState = {
  orderHistoryList: [],
  patientOrderHistoryList: [],
  orderDetail: null,
  salesOrderList: [],
};

export const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ORDER_HISTORY_RECEIVED: {
      return {
        ...state,
        orderHistoryList: action.payload,
      };
    }
    case PATIENT_ORDER_HISTORY_RECEIVED: {
      return {
        ...state,
        patientOrderHistoryList: action.payload,
      };
    }
    case ORDER_DETAIL_RECEIVED: {
      return {
        ...state,
        orderDetail: action.payload,
      };
    }
    case SALES_ORDER_RECEIVED: {
      return {
        ...state,
        salesOrderList: action.payload,
      };
    }
    default:
      return state;
  }
};
